import { EventItem } from '../data-types/sports/sportsInterfaces';
import { setSportsbookEvents } from '../state/actions/sportsbookEventsActions';
import { store } from '../state/store';
import { SportsbookEventsState } from '../state/types/sportsbookEventsType';

export const setSportsbookEventsInRedux = (events: EventItem[]) => {
  const eventsMap: SportsbookEventsState = {};

  events.forEach(event => {
    eventsMap[`${event.sportId}-${event.id}`] = event;
  });

  setSportsbookEvents(eventsMap);
};

export const addSportsbookEventsInRedux = (events: EventItem[]) => {
  const { sportsbookEvents } = store.getState();
  const eventsMap: SportsbookEventsState = {};

  events.forEach(event => {
    eventsMap[`${event.sportId}-${event.id}`] = event;
  });

  setSportsbookEvents({ ...sportsbookEvents, ...eventsMap });
};

export const getKeysFromEventsMap = (eventsMap: SportsbookEventsState): string[] => Object.keys(eventsMap);

export const getEventsListFromMap = (eventsMap: SportsbookEventsState): EventItem[] => Object.keys(eventsMap).map(key => eventsMap[key]);

export const getNumberOfEvents = (eventsMap: SportsbookEventsState): number => getKeysFromEventsMap(eventsMap).length;

export const eventExistsInMap = (event: EventItem, eventsMap: SportsbookEventsState) => {
  const existingKeys = getKeysFromEventsMap(eventsMap);

  return existingKeys.includes(`${event.sportId}-${event.id}`);
};

export const anyOutrightsInTheEventsList = (eventsMap: SportsbookEventsState) => {
  for (const key of getKeysFromEventsMap(eventsMap)) {
    const event = eventsMap[key];

    if (event && !!event.isOutright) {
      return true;
    }
  }

  return false;
};

export const anyNonOutrightsInTheEventsList = (eventsMap: SportsbookEventsState) => {
  for (const key of getKeysFromEventsMap(eventsMap)) {
    const event = eventsMap[key];

    if (event && !event.isOutright) {
      return true;
    }
  }

  return false;
};

export const getOutrightsFromEventsList = (eventsMap: SportsbookEventsState) => {
  const outrights: EventItem[] = [];

  getKeysFromEventsMap(eventsMap).forEach(key => {
    const event = eventsMap[key];

    if (event && !!event.isOutright) {
      outrights.push(event);
    }
  });

  return outrights;
};

export const getNonOutrightsFromEventsList = (eventsMap: SportsbookEventsState) => {
  const events: EventItem[] = [];

  getKeysFromEventsMap(eventsMap).forEach(key => {
    const event = eventsMap[key];

    if (event && !event.isOutright) {
      events.push(event);
    }
  });

  return events;
};
